import { PropsWithChildren } from "react";
import { AnimationProps, motion } from "framer-motion";

const variants = {
  enter: { x: "100%", opacity: 0 },
  center: { x: 0, opacity: 1 },
  exit: { x: "-100%", opacity: 0 },
};

interface AnimatedModalPageProps extends PropsWithChildren {
  initial: keyof typeof variants;
  exit?: keyof typeof variants;
  animationProps?: AnimationProps;
}

export const AnimatedPage = ({
  initial,
  exit = "exit",
  animationProps,
  children,
}: AnimatedModalPageProps) => {
  return (
    <motion.div
      {...{
        initial,
        animate: "center",
        exit,
        variants,
        transition: {
          duration: 0.45,
          ease: "easeInOut",
          stiffness: 70,
          damping: 13,
          type: "spring",
        },
        ...animationProps,
      }}
    >
      {children}
    </motion.div>
  );
};
